import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Errors } from 'react-redux-form';
import { Redirect } from 'react-router-dom';
import get from 'lodash/get';
import EmploymentInfo from '../Forms/EmploymentInfo';
import Finances from '../Forms/Finances';
import Disclosures from '../Forms/Disclosures';

import { investmentInfoPath } from '../Forms/Schemas/baseRrf';

import Button from '../Button';
import './InvestmentInfoRrf.css';

// const debug = require('debug')('cambria:SignUp:PersonalInfo');


class InvestmentInfo extends Component {
  componentDidMount() {
    window.addEventListener('beforeunload', this.handleLeavePage);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }
  onSubmit = async () => {
    this.props.onNext();
  };

  handleLeavePage = (e) => {
    const { isInvestmentInfoPristine } = this.props;
    if (!isInvestmentInfoPristine) {
      e.preventDefault();
      e.returnValue = '';
    }
  };

  render() {
    const {
      employmentStatus,
      finraAffiliated,
      directorOrTenPercentShareholder,
      authTokenUser,
    } = this.props;
    if (!authTokenUser) {
      return <Redirect to="/login" push={false} />;
    }
    return (
      <div className="SignUpInvestmentInfo">
        <Form
          model={investmentInfoPath}
          onSubmit={this.onSubmit}
          validators={{
            '': {
              netWorths: vals => ((
                  vals.finances &&
                  !!vals.finances.liquidNetWorth &&
                  !!vals.finances.totalNetWorth
                ) ? vals.finances.liquidNetWorth <= vals.finances.totalNetWorth : true),
            },
          }}
        >
          <div styleName="investmentFormHead">Additional information required to begin investing</div>
          <div styleName="textInputs">
            <EmploymentInfo
              employPath=".employment"
              showAdditional={employmentStatus === 'Self-Employed' || employmentStatus === 'Employed'}
            />
          </div>
          <div styleName="textInputs">
            <Finances
              financesPath=".finances"
            />
            <Errors
              styleName="errorText"
              show={form => form.touched || form.submitted}
              model={investmentInfoPath}
              messages={{
                  netWorths: 'Liquid Net Worth can not be greater than Total Net Worth.',
                }}
            />
          </div>
          <div styleName="textInputs">
            <Disclosures
              disclosuresPath=".disclosures"
              isFinra={finraAffiliated}
              isDirector={directorOrTenPercentShareholder}
            />
          </div>
          <div styleName="submitButtonContainer">
            <Button type="submit">Continue</Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  employmentStatus: get(state, `${investmentInfoPath}.employment.employmentStatus`, ''),
  directorOrTenPercentShareholder: get(state, `${investmentInfoPath}.disclosures.directorOrTenPercentShareholder`, false),
  finraAffiliated: get(state, `${investmentInfoPath}.disclosures.finraAffiliated`, false),
  authTokenUser: state.authTokenUser,
  isInvestmentInfoPristine: get(state.rrSignupForms, 'forms.investmentInfo.$form.pristine', true),
});

export default connect(mapStateToProps, null)(InvestmentInfo);



// WEBPACK FOOTER //
// ./src/components/SignUp/InvestmentInfoRrf.js